<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-3 pt-0 pb-2 min-vh-50">
              <form id="search" class="mt-3" @submit.prevent="getRFQ">
                <div class="row g-2 d-flex justify-content-end">
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">RFQ Number</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <input v-model="search.rfq_number" type="text" class="form-control" placeholder="RFQ Number" aria-label="RFQ Number" aria-describedby="basic-addon1">
                    </div>
                  </div>
                  <div class="col-12 col-sm-4">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">RFQ Date</label>
                    <Datepicker 
                      v-model="search.rfq_date" 
                      range
                      format="dd MMM yyyy"/>
                  </div>
                  <div class="col-12 col-sm-1 align-self-end">
                    <button type="submit" class="btn btn-sm btn-primary mb-0">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </form>
              <hr class="my-2"/>
              <div class="d-flex justify-content-end">
                <p class="align-self-center text-xs text-secondary">{{ current_page }} - {{ current_total_data }} / {{ total_data }}</p>
                <argon-pagination color="gradient-primary" size="sm">
                  <argon-pagination-item
                  @click="prevPage"
                    prev
                    :disabled="offset === 0 ? true : false" />
                  <argon-pagination-item
                    @click="nextPage"
                    next
                    :disabled="record_more === false ? true : false" />
                </argon-pagination>
              </div>
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="bg-light">
                      <th class="text-uppercase text-xxs fw-bolder">Reference</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Order Date</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Expected Arrival</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Type of Procurement</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Status</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="rfq in rfq_list" :key="rfq.purchase_id">
                      <td>
                          <router-link :to="'/rfq/' + rfq.purchase_id" class="text-xs text-primary fw-bold mb-0 ps-3">
                            {{ rfq.name }}
                          </router-link>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ rfq.date_order }}</p>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ rfq.date_planned }}</p>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ rfq.type_of_procurement }}</p>
                      </td>
                      <td class="align-middle text-sm">
                        <argon-badge color="info" class="align-self-center" size="sm">{{ rfq.state }}</argon-badge>
                      </td>
                      <td class="align-middle">
                        <span class="text-secondary text-xs">{{ rfq.amount_total }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!rfq_list.length > 0 && !loading"/>
              <loading-state v-if="loading == true"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";
import EmptyState from "./components/EmptyState.vue";
import LoadingState from "./components/LoadingState.vue";
const endpoint = require("../router/endpoint");
export default {
    name: 'RFQ',
    components: {
      ArgonPagination,
      ArgonPaginationItem,
      ArgonBadge,
      EmptyState,
      LoadingState,
    },
    data () {
      return {
        loading: false,
        total_data: 0,
        current_total_data: 0,
        current_page: 0,
        offset: 0,
        record_more: false,
        search: {
          rfq_number: null,
          rfq_date: [],
        },
        rfq_list: [],
      }
    },
    methods: {
      prevPage() {
      if (this.offset > 0) {
          this.offset = this.offset - 10
          this.getRFQ()
        }
      },
      nextPage() {
        if (this.record_more === true) {
          this.offset = this.offset + 10
          this.getRFQ()
        }
      },
      getDate(daterange) {
      var dateList = []
      if (daterange !== null){
        if (daterange.length > 0) {
          daterange.forEach(date => {
            if (date) {
              let month = date.getMonth() >= 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
              let fullDate = date.getFullYear() + '-' + month + '-' + date.getDate()
              dateList.push(fullDate)
            }
          });
        }
      }
      return dateList
    },
      getRFQ() {
        this.loading = true
        this.rfq_list = []
        this.total_data = 0
        this.current_total_data = 0
        this.record_more = false
        this.current_page = 0
        let rfq_date = this.getDate(this.search.rfq_date)
        let offset = 0
        if (rfq_date.length > 0 || this.search.rfq_number) {
          offset = 0
        } else {
          offset = this.offset
        }
        this.axios
        .post(
          endpoint.RFQ_LIST,
          {
            name: this.search.rfq_number || "",
            date_from: rfq_date.length > 0 ? rfq_date[0] : "",
            date_to: rfq_date.length > 1 ? rfq_date[1] : "",
            partner_id: parseInt(localStorage.getItem('partner_id')),
            limit: 10,
            offset: offset
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            this.rfq_list = response.data.data;
            this.total_data = response.data.total_data
            this.current_total_data = response.data.current_total_data
            this.record_more = response.data.record_more
            this.current_page = response.data.current_page
            this.loading = false
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
            }
            this.loading = false
          }
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: e.response.data.message || e,
          });
          this.loading = false
        });
      }
    },
    mounted() {
      this.getRFQ()
    }
}
</script>

<style>

</style>